var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, IconButton } from "@mui/material";
import { useItemDetailStyles } from "./useItemDetailStyles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
export const CustomLeftArrow = (_a) => {
    var props = __rest(_a, []);
    const { onClick, arrowColor } = props;
    const classes = useItemDetailStyles(props);
    //Width of the button will overlay at least half of the card displayed
    return (_jsx(Box, Object.assign({ style: {
            position: "absolute",
            left: "3%",
        }, display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", onClick: () => onClick() }, { children: _jsx(IconButton, Object.assign({ className: classes.customHoverFocus, size: "large" }, { children: _jsx(ChevronLeftIcon, { style: { color: arrowColor } }) })) })));
};
